<template>
  <div>
    <div id="piaoju" style="display: none;">
      <div class="hiprint-printTemplate" id="jing">
        <div class="hiprint-printPanel panel-index-0">
          <div class="hiprint-printPaper" original-height="250" style="width: 200mm; height: 260mm;">
            <div class="hiprint-printPaper-content">
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 200mm; font-size: 23pt; font-weight: 600; letter-spacing: 2.5pt; color: rgb(41, 53, 227); text-align: center; line-height: 18pt;  top: 2pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">{{info.title}}</div>
            </div>
            <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 200mm; font-size: 22pt; font-weight: 600; letter-spacing: 2.5pt; color: rgb(41, 53, 227); text-align: center; line-height: 18pt;  top: 30pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">门诊专用处方笺</div>
            </div>
            <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 40pt; height: 40pt; border-radius:15pt;font-size: 17pt; border:1px solid rgb(41, 53, 227); color: rgb(41, 53, 227); text-align: center; line-height: 40pt; left: 480pt; top: 15pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">精二</div>
            </div>
            <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position:absolute;width: 100pt;height:15pt;color:rgb(41, 53, 227);font-size: 17pt;text-align:left;line-height:13pt;left: 20pt;top: 60.5pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">费别：{{info.dict_pay_cate}}</div>
            </div>
            <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 180pt; height: 15pt; color: rgb(41, 53, 227); font-size: 17pt;text-align: left; line-height: 13pt; left: 170pt; top: 60.5pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">科别：{{info.department}}</div>
            </div>
            <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 250pt; height: 15pt; color: rgb(41, 53, 227); font-size: 17pt;text-align: left; line-height: 13pt; left: 320pt; top: 60.5pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">开具日期：{{info.date}}</div>
            </div>
            <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 150pt; height: 15pt; color: rgb(41, 53, 227); font-size: 17pt;text-align: left; line-height: 13pt; left: 20pt; top: 85pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">姓名：{{info.name}}</div>
            </div>
            <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 180pt; height: 15pt; color: rgb(41, 53, 227); font-size: 17pt;text-align: left; line-height: 13pt; left: 170pt; top: 85pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">性别：{{info.dict_sex_name}}</div>
            </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 250pt; height: 15pt; color: rgb(41, 53, 227); font-size: 17pt;text-align: left; line-height: 13pt; left: 320pt; top: 85pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">门诊号：{{info.ipt_otp_no}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position:absolute;width: 100pt;height:15pt;color:rgb(41, 53, 227);font-size: 17pt;text-align:left;line-height:13pt;left: 20pt;top: 110pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">年龄：{{info.age}}岁</div>
              </div>

              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 180pt; height: 15pt; color: rgb(41, 53, 227); font-size: 17pt;text-align: left; line-height: 13pt; left: 170pt; top: 110pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">电话：{{info.mobile_phone}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 340pt; height: 15pt; color: rgb(41, 53, 227); font-size: 17pt;text-align: left; line-height: 13pt; left: 320pt; top: 110pt;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">身份证号：{{info.cert_no}}</div>
            </div>
              <!-- <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position:absolute;width: 180pt;height:15pt;color:rgb(41, 53, 227);font-size: 17pt;text-align:left;line-height:13pt;left: 20pt;top: 120pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">科别：{{info.department}}</div>
              </div> -->
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position:absolute;width: 190mm;color:rgb(41, 53, 227);font-size: 17pt;text-align:left;line-height:16pt;left: 20pt;top: 135pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">诊断：{{info.diagnosis_name_list}}</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-top: 1pt solid rgb(41, 53, 227);  position: absolute; width: 200mm; height: 282pt; left: 0pt; top: 176pt;">
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 140pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 10pt; top: 181pt;font-size: 24pt;font-weight: 400;font-family: Microsoft YaHei !important;">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%">Rp</div>
            </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute;  height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 40pt; top: 200pt;font-size: 17pt;">
                <div v-for="(item,index) in dataList" :key="index">
                  <div style="display: flex;justify-content: space-between;align-items: start; width: 180mm;margin-top: 5pt;">
                    <div
                      style="width: 420pt; color: rgb(41, 53, 227); text-align: left; font-size: 16pt;line-height: 20pt;">
                     {{item.drug}}【{{item.medi_spec}} * {{item.min_package_num}} {{item.min_unit_name }}/ {{item.min_package_unit_name}}】
                    </div>
                    <div
                      style="width: 100pt; height: 20pt; color: rgb(41, 53, 227); text-align: left; font-size: 16pt;left: 10pt;top:5pt">
                      {{item.num}}{{item.dict_first_unit_name}}</div>
                  </div>
                  <div style="display: flex;justify-content: space-between;align-items: center; width: 180mm;margin-top: 5pt;">
                    <div
                      style=" width: 200pt; height: 20pt; color: rgb(41, 53, 227); text-align: left; line-height: 20pt;font-size: 16pt;">
                      用法:{{item.dosage}}{{item.dict_dosage_unit_name}}</div>
                    <div
                      style="width: 200pt; height: 20pt; color: rgb(41, 53, 227); text-align: left; line-height: 20pt;font-size: 16pt;left: 150pt;top:15pt">
                      {{item.dict_use_type_name}}</div>
                    <div
                      style="width: 120pt; height: 20pt; color: rgb(41, 53, 227); text-align: right; line-height: 20pt;font-size: 16pt;left: 10pt;top:15pt">
                      {{item.dict_frequency_name}}</div>
                  </div>
                  <div v-if="isPrint=='true'" style="display: flex;justify-content: space-between;align-items: center; width: 200mm;margin-top: 5pt;">
                    <div
                      style=" width: 520pt; height: 20pt; color: rgb(41, 53, 227); text-align: left; line-height: 20pt;font-size: 16pt;">
                      备注:{{item.remark}}</div>
                  </div>
                </div>

              </div>
              <!-- 中间表格 -->
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
              style="position: absolute; width: 180pt; height: 10pt; color: rgb(41, 53, 227); left: 10pt;font-size: 17pt; top: 185pt;">
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 180pt; height: 10pt; color: rgb(41, 53, 227); left: 15pt;font-size: 17pt; top: 415pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">医师：{{info.doctor_name}}</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-bottom: 1pt solid rgb(41, 53, 227);font-size: 17pt;  position: absolute; width: 100pt; height: 18pt; left: 42pt; top: 410pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%"></div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 300pt; height: 10pt;font-size: 17pt; color: rgb(41, 53, 227); left: 330pt; top: 415pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">审核：</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-bottom: 1pt solid rgb(41, 53, 227); font-size: 17pt; position: absolute; width: 100pt; height: 18pt; left: 222pt; top: 410pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%"></div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 150pt; height: 10pt; font-size: 17pt;color: rgb(41, 53, 227); left: 150pt; top: 415pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">药品金额：{{info.total_fee}}</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-bottom: 1pt solid rgb(41, 53, 227);  font-size: 17pt;position: absolute; width: 100pt; height: 18pt; left: 370pt; top: 410pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%"></div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 100pt; height: 10pt; font-size: 17pt;color: rgb(41, 53, 227); left: 15pt; top: 455.5pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">调配：</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-bottom: 1pt solid rgb(41, 53, 227);  font-size: 17pt;position: absolute; width: 100pt; height: 18pt; left: 42pt; top: 450pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%"></div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 300pt; height: 10pt;font-size: 17pt; color: rgb(41, 53, 227); left: 330pt; top: 455.5pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">发药：</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-bottom: 1pt solid rgb(41, 53, 227); font-size: 17pt; position: absolute; width: 100pt; height: 18pt; left: 222pt; top: 450pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%"></div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 150pt; height: 10pt; font-size: 17pt;color: rgb(41, 53, 227); left: 150pt; top: 455.5pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">核对：</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border:none;border-bottom: 1pt solid rgb(41, 53, 227);  font-size: 17pt;position: absolute; width: 100pt; height: 18pt; left: 370pt; top: 450pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%"></div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
              style="border:none;border-bottom: 1pt solid rgb(41, 53, 227);  font-size: 17pt;position: absolute; width: 280pt; height: 18pt; left: 120pt; top: 250pt;transform: rotate(108deg);">
              <div class="hiprint-printElement-text-content hiprint-printElement-content"
                style="height:100%;width:100%"></div>
            </div></div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted, defineExpose } from 'vue';
  const info = ref('')
  const dataList = ref([])
  const isPrint = process.env.VUE_APP_PRINT
  console.log(isPrint)
  onMounted(() => {

  })
  const initData = (item) => {
    dataList.value = []
    info.value = {}
    info.value = item
    dataList.value = JSON.parse(JSON.stringify(info.value.drug_list))
    console.log(111, dataList.value)
  }
  //A4的panel设置
  const a4Panel = { width: 211, height: 280, paperHeader: 5, paperNumberDisabled: true ,'orient': 1}
  import { autoConnect, disAutoConnect, hiprint, defaultElementTypeProvider } from 'vue-plugin-hiprint'
  // disAutoConnect()// 取消自动连接直接打印客户端
  hiprint.init()//初始化
  const print = (title) => {
    let hiprintTemplate = new hiprint.PrintTemplate();
    let panel = hiprintTemplate.addPrintPanel(a4Panel);
    panel.addPrintHtml({ options: { width: 211, height: 280, top: 40, left: 10, content: $('#jing').html() } });
    //打印
    hiprintTemplate.print();
  }
  defineExpose({
    info,
    print,
    initData,
    isPrint
  })
</script>
<style scoped>
  .patentList {
    background-color: #fff;
  }
</style>